var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-select',{staticClass:"mb-0",attrs:{"items":_vm.packages,"outlined":"","dense":"","disabled":_vm.packages.length === 0,"item-text":"text","item-value":"id"},on:{"change":_vm.onChange},model:{value:(_vm.selectedPackage),callback:function ($$v) {_vm.selectedPackage=$$v},expression:"selectedPackage"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }